import { routes } from '../../constants/routes';

const NoticeConstants = {
  boardType: 'NoticeBoard',
  boardName: '공지사항',
  pageSize: 10,
  listPage: routes.customer.notice,
  is_show_pc: true,
};
const EventConstants = {
  boardType: 'NoticeBoard',
  boardName: '학부모이벤트',
  is_show_pc: true,
  pageSize: 50,
  listPage: routes.customer.event,
  detailPage: routes.customer.event,
};

const BannerConstants = {
  boardType: 'NoticeBoard',
  pageSize: 50,
  boardName: '학부모배너',
  is_show_pc: true,
};

const MENU_LABELS = [
  { label: '공지사항', link: 'noticelist' },
  { label: '이벤트', link: 'event' },
  { label: '자주하는 질문', link: 'question' },
  { label: '신고 · 건의 · 문의', link: 'report' },
  { label: '앱다운로드', link: 'download' },
  { label: '선생님 지원', link: 'teacher' },
];

export { EventConstants, BannerConstants, NoticeConstants, MENU_LABELS };
